import { ClientCodeResolver, clientUrlType } from './clientCodeResolver';
import { logger } from './logger';

let clientResovled = ClientCodeResolver.resolveClientFromUrl(location.host, location.pathname);

if (clientResovled.clientUrltype === clientUrlType.localHost || clientUrlType.depricatedLocalHost) {
  logger.debug('localhost host found, falling back if client not found');
}

export const clientResolution = clientResovled;

console.log(clientResovled.clientCode);

if (clientResovled.clientCode === '') {
  logger.error('invalid client provided %s ', location.href);
  throw new Error('invalid client provided');
}

logger.debug('using client %s', clientResovled.clientCode);